module.exports = __webpack_public_path__ + "static/fulla-mobil-2a1e62bfba57da7952b40a6cda89bdd3.png";